import Images from '../../Images'
import './Footer.css'

function Footer () {
  return (
    <footer>
      <div className="footer-main">
        <div className="footer-left">
          <img alt="" srcSet={Images.FooterLogo} />
          <div className="footer-socials-sep"></div>
          <div className="footer-socials">
            <a
              href="https://www.facebook.com/equipeiGEMULaval/"
              target="_blank"
              rel="noreferrer"
              className="socials-clickable"
            >
              <img srcSet={Images.LogoFB} alt="" />
            </a>
            <a
              href="https://www.instagram.com/igem_ulaval/"
              target="_blank"
              rel="noreferrer"
              className="socials-clickable"
            >
              <img srcSet={Images.LogoInsta} alt="" />
            </a>
          </div>
        </div>
        <div className="footer-right">
          <div className="footer-right-title">Thank you to our sponsors</div>
          <img srcSet={Images.Commandites} alt="" />
        </div>
      </div>
      <div className="footer-bottom">
        <div className="row mt-4">
          <div className="col">
            <p className="legal-mentions">
              <small>
                © 2023 - Content on this site is licensed under a{' '}
                <a
                  className="subfoot"
                  href="https://creativecommons.org/licenses/by/4.0/"
                  rel="license"
                >
                  Creative Commons Attribution 4.0 International license
                </a>
                .
              </small>
            </p>
            <p className="legal-mentions">
              <small>
                The repository used to create this website is available at{' '}
                <a href="https://gitlab.igem.org/2023/ulaval">
                  gitlab.igem.org/2023/ulaval
                </a>
                .
              </small>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
